// extracted by mini-css-extract-plugin
module.exports = {"container":"_a70cd179","dropDown":"_16738905","fullWidth":"_fd4982b","label":"_fbc4a918","selection":"_eadbe57e","down":"_852f64ec","selectOptions":"_85fb5586","arrow":"_8ca09527"};